import { DependencyList, useEffect } from 'react';

interface UseScriptConfig {
  id: string;
  container?: HTMLElement;
  // src - link to js file, innerText - script as innerText
  mode?: 'src' | 'innerText';
}

/**
 * Re-creates, and thus reloads, the script when `deps` change. Inserts the new script into `document.body` by default.
 * */
export function useScript(codeOrUrl: string, config: UseScriptConfig, deps?: DependencyList) {
  useEffect(() => {
    const { id, container = document.body, mode = 'src' } = config;

    const existingScript = document.getElementById(id);

    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');

    script.id = id;
    script[mode] = codeOrUrl;

    container.appendChild(script);
  }, deps);
}
